import { createAction, props } from '@ngrx/store'

export const setUser = createAction('[stage] Setting user', props<{ user: string }>())
